export default "__VITE_ASSET__268bb403__"